<template>
  <AdminShell
    :page-title="pageTitle"
    :page-subtitle="pageSubtitle"
    active-menu="visits"
  >
    <StatsVisits :base="baseUrl" />
  </AdminShell>
</template>

<script>
import AdminShell from '@/components/admin/AdminShell.vue'
import StatsVisits from '@/components/StatsVisits.vue'

const baseUrl = process.env.NODE_ENV == 'production' ? 'https://anal.wokfoy.com' : 'https://anal.wokfoy.com'
const PAGE_TITLE = '\u8bbf\u95ee\u8bb0\u5f55'
const PAGE_SUBTITLE = '\u67e5\u770b\u76f4\u64ad\u8bbf\u95ee\u94fe\u8def\u3001\u62c9\u6d41\u7ed3\u679c\u4e0e\u5173\u952e\u4e8b\u4ef6\u660e\u7ec6\u3002'

export default {
  name: 'VisitsTablePage',
  components: {
    AdminShell,
    StatsVisits,
  },
  data() {
    return {
      baseUrl,
      pageTitle: PAGE_TITLE,
      pageSubtitle: PAGE_SUBTITLE,
    }
  },
}
</script>
